import { globalSingleton } from './chunk-N7SZ66QO.js';
import { z } from 'zod';

// src/metadata-analytics/protocol-names.generated.json
var protocol_names_generated_default = {
  categories: {
    aave_ccip: "bridge",
    aave_gateway: "bridge",
    aave_gho: "lending",
    aave_governance: "governance",
    aave_safety_module: "staking",
    aave_umbrella: "staking",
    aave_v2: "lending",
    aave_v3: "lending",
    aave_v4: "lending",
    account_closure: "infrastructure",
    accounting_ccip_receiver: "bridge",
    across: "bridge",
    address_lookup_table: "infrastructure",
    aerodrome: "exchange",
    aldrin: "exchange",
    aldrin_v2: "exchange",
    algebra: "exchange",
    algebra_router: "exchange",
    allbridge_core: "bridge",
    allbridge_core_cctp: "bridge",
    alphaq: "exchange",
    ambient: "exchange",
    amnis: "staking",
    angstrom: "exchange",
    ape_church: "gambling",
    aquifer: "exchange",
    arbitrage_bot_foaft: "mev",
    arbitrum_bridge: "bridge",
    arbos: "infrastructure",
    arcas_ccip_receiver: "bridge",
    archer: "exchange",
    associated_token_account: "erc20",
    babylon_staking: "staking",
    backed_ccip_bridge: "bridge",
    backed_ccip_receiver: "bridge",
    balancer_v2: "exchange",
    balancer_v3: "exchange",
    banana_gun: "mev",
    bebop: "exchange",
    binaryfi: "exchange",
    bisonfi: "exchange",
    bisonfi_predict: "exchange",
    bitcoin_org: "infrastructure",
    bitcoin_stamps: "nft",
    blur: "nft",
    bonkswap: "exchange",
    boop_fun: "exchange",
    bpf_loader: "infrastructure",
    bpf_loader2: "infrastructure",
    bpf_loader_upgradeable: "infrastructure",
    brc20: "erc20",
    bridge_ccip_receiver: "bridge",
    byreal: "exchange",
    candide: "account_abstraction",
    carrot: "staking",
    cashmere_cctp: "bridge",
    cashmere_cctp_program: "bridge",
    ccip_burnmint_token_pool: "bridge",
    ccip_cctp_token_pool: "bridge",
    ccip_fee_quoter: "bridge",
    ccip_lockrelease_token_pool: "bridge",
    ccip_offramp: "bridge",
    ccip_prover: "bridge",
    ccip_rmn_remote: "bridge",
    ccip_router: "bridge",
    ccipeth_ccip_receiver: "bridge",
    cctp: "bridge",
    cctp_message_transmitter: "bridge",
    cctp_message_transmitter_v2: "bridge",
    cctp_token_messenger_minter: "bridge",
    cctp_token_messenger_minter_v2: "bridge",
    chainflip: "bridge",
    chainlink_automation: "oracle",
    chainlink_ccip: "bridge",
    chainlink_data_feeds: "oracle",
    chainlink_data_streams: "oracle",
    chainlink_direct_request: "oracle",
    chainlink_functions: "oracle",
    chainlink_staking: "staking",
    chainlink_vrf: "oracle",
    circle_bridge_kit: "bridge",
    circle_ccts: "bridge",
    circle_fiattokenfactory: "infrastructure",
    circle_usdc_xrpl: "other",
    compound_v3: "lending",
    compute_budget: "infrastructure",
    conditional_tokens: "derivatives",
    coredao: "staking",
    cosmos_authz: "account_abstraction",
    cosmos_bank: "infrastructure",
    cosmos_distribution: "staking",
    cosmos_feegrant: "account_abstraction",
    cosmos_gov: "governance",
    cosmos_staking: "staking",
    cosmwasm: "infrastructure",
    counterparty: "exchange",
    cowswap: "exchange",
    credit_coop_bridge: "bridge",
    crema: "exchange",
    cropper: "exchange",
    cryptopunks: "nft",
    curve: "exchange",
    curve_steth: "exchange",
    custom_staking_ccip_receiver: "bridge",
    da_builder: "aggregator",
    defituna: "exchange",
    denali: "exchange",
    deriverse: "exchange",
    dexlab: "exchange",
    dflow_aggregator_v4: "aggregator",
    drift_ccip_receiver: "bridge",
    ed25519_program: "infrastructure",
    eigenlayer: "staking",
    eip7702: "account_abstraction",
    ekubo: "exchange",
    ens: "nft",
    enso: "bridge",
    erc1155: "nft",
    erc20: "erc20",
    erc4337: "account_abstraction",
    erc4626: "lending",
    erc721: "nft",
    ethena: "staking",
    ether_ccip_receiver: "bridge",
    etherfi: "staking",
    euler: "lending",
    flint: "exchange",
    fluid: "exchange",
    fluid_dex: "exchange",
    flux: "exchange",
    fluxbeam: "exchange",
    folks_finance: "bridge",
    frax_ether: "staking",
    gatorswap: "exchange",
    gavel: "exchange",
    generic: "other",
    gnosis_safe: "safe",
    goonfi_v2: "exchange",
    goosefx_gamma: "exchange",
    guacswap: "exchange",
    gyd_escrow_ccip_receiver: "bridge",
    hadron: "exchange",
    heaven: "exchange",
    helium_treasury: "staking",
    hop: "bridge",
    huma: "staking",
    humidifi: "exchange",
    hylo_exchange: "staking",
    hylo_stability_pool: "staking",
    hyperlane: "bridge",
    hyperliquid_account: "account_abstraction",
    hyperliquid_bridge: "bridge",
    hyperliquid_bridge2: "bridge",
    hyperliquid_evm: "infrastructure",
    hyperliquid_staking: "staking",
    hyperliquid_trading: "derivatives",
    hyperliquid_transfer: "exchange",
    hyperliquid_validator: "infrastructure",
    hyperliquid_vault: "derivatives",
    ibc_core: "infrastructure",
    ibc_transfer: "bridge",
    invariant: "exchange",
    jaredfromsubway: "mev",
    joinmarket_coinjoin: "privacy",
    jupiter_dca: "exchange",
    jupiter_lend_earn: "lending",
    jupiter_limit_order: "exchange",
    jupiter_limit_order_v2: "exchange",
    jupiter_order_engine: "exchange",
    jupiter_perps: "derivatives",
    jupiter_rfq_v2: "exchange",
    jupiter_v4: "aggregator",
    jupiter_v6: "aggregator",
    juplend_amm: "exchange",
    kipseli: "exchange",
    kmon_minter_ccip_receiver: "bridge",
    kyber_legacy: "exchange",
    kyberswap_fairflow: "exchange",
    kyberswap_limit_order: "exchange",
    kyberswap_meta_aggregator: "aggregator",
    kyberswap_zap: "exchange",
    laposte: "bridge",
    layerzero_oft: "bridge",
    layerzero_v1: "bridge",
    layerzero_v2: "bridge",
    lemmingsfi: "exchange",
    lido: "staking",
    lifi: "aggregator",
    lifi_receivers: "aggregator",
    lifi_solana_program_1: "infrastructure",
    lifinity_v2: "exchange",
    lighthouse: "infrastructure",
    limitbreak_payment_processor: "nft",
    linea_bridge: "bridge",
    linear_ccip_receiver: "bridge",
    liquidswap: "exchange",
    loader_v4: "infrastructure",
    lombard: "bridge",
    m_swap: "exchange",
    magic_eden_v2: "nft",
    maker_dss: "lending",
    manifest: "exchange",
    maple: "lending",
    marinade: "staking",
    maverick_v2: "exchange",
    mayan: "bridge",
    mayan_cpi_proxy: "infrastructure",
    mayan_fast_mctp: "bridge",
    mayan_fee_manager: "bridge",
    mayan_mctp: "bridge",
    mayan_spl_utils: "infrastructure",
    mercurial: "exchange",
    metadao: "exchange",
    metamask_bridge: "aggregator",
    metamask_delegation: "account_abstraction",
    metamask_swaps: "aggregator",
    metaplex_bubblegum: "nft",
    metaplex_core: "nft",
    metaplex_token_metadata: "nft",
    meteora_damm_v2: "exchange",
    meteora_dbc: "exchange",
    meteora_dlmm: "exchange",
    meteora_pools: "exchange",
    metric: "exchange",
    mev_bot: "mev",
    monero_ringct: "privacy",
    moonit: "exchange",
    morpho_blue: "lending",
    morpho_bundler3: "lending",
    mtoken: "bridge",
    multi_lock_mint_ccip_receiver: "bridge",
    multicall: "aggregator",
    native_ccip_receiver: "bridge",
    native_loader: "infrastructure",
    native_transfer: "erc20",
    near_intents: "bridge",
    nft_floor_ccip_receiver: "bridge",
    noble_forwarding: "infrastructure",
    obric_v2: "exchange",
    obsidian: "exchange",
    odos: "aggregator",
    okx_dex_router: "aggregator",
    okx_xbridge: "aggregator",
    omni_layer: "erc20",
    omnipair: "exchange",
    one_dex: "exchange",
    oneinch: "aggregator",
    oneinch_executor: "aggregator",
    op_fork_bridge: "bridge",
    op_return_data: "other",
    op_stack_bridge: "bridge",
    op_stack_l1_block: "infrastructure",
    openbook_v2: "exchange",
    orca_v1: "exchange",
    orca_v2: "exchange",
    orca_whirlpool: "exchange",
    ordinals: "nft",
    origin_protocol: "bridge",
    osmosis_swap: "exchange",
    outland: "bridge",
    packed_steps: "aggregator",
    pancakeswap_factory: "exchange",
    pancakeswap_router: "exchange",
    pancakeswap_solana: "exchange",
    pancakeswap_v3_pool: "exchange",
    pangolin_v3: "exchange",
    paraswap: "exchange",
    pendle: "derivatives",
    penguin: "exchange",
    perena: "exchange",
    perena_star_v2: "staking",
    phoenix: "exchange",
    phoenix_eternal: "derivatives",
    polygon_cdk_bridge: "bridge",
    polygon_pos_bridge: "bridge",
    polymarket_ctf_exchange: "derivatives",
    polymarket_neg_risk: "derivatives",
    polymarket_uma_adapter: "derivatives",
    pons_v2_curve: "exchange",
    pons_v2_factory: "exchange",
    privacy_pools: "privacy",
    private_packed_searchers: "mev",
    program_metadata: "infrastructure",
    pumpfun: "exchange",
    pumpfun_fee: "exchange",
    pumpswap_amm: "exchange",
    quantum: "exchange",
    quay: "exchange",
    railgun: "privacy",
    rare_bridge_ccip_receiver: "bridge",
    raydium_amm_v4: "exchange",
    raydium_clmm: "exchange",
    raydium_cpmm: "exchange",
    raydium_launchlab: "exchange",
    relay: "bridge",
    ripple_rlusd: "other",
    riptide: "exchange",
    rootstock: "bridge",
    runes: "erc20",
    runespear: "bridge",
    runner_rodeo: "exchange",
    saber: "exchange",
    saber_decimals: "exchange",
    sanctum_infinity: "staking",
    sanctum_multi_validator: "staking",
    sanctum_prop_s: "staking",
    sanctum_router: "staking",
    sanctum_single_validator: "staking",
    sanctum_sols: "staking",
    sanctum_spl_stake_pool: "staking",
    saros: "exchange",
    saros_dlmm: "exchange",
    scale_amm: "exchange",
    scale_vmm: "exchange",
    scorch: "exchange",
    scorch_2: "exchange",
    scroll_bridge: "bridge",
    seaport: "nft",
    secp256k1_program: "infrastructure",
    sky_usds: "lending",
    socket: "bridge",
    solayer: "staking",
    solfi: "exchange",
    solfi_v2: "exchange",
    soucore_ccip_receiver: "bridge",
    spl_memo_v1: "infrastructure",
    spl_memo_v2: "infrastructure",
    spl_token: "erc20",
    spl_token_2022: "erc20",
    spl_token_swap: "exchange",
    stabble_clmm: "exchange",
    stabble_stable_swap: "exchange",
    stabble_weighted_swap: "exchange",
    stableswap: "exchange",
    stacks: "infrastructure",
    stake: "infrastructure",
    stargate: "bridge",
    stepn: "exchange",
    strap_guard: "infrastructure",
    sushiswap_router: "exchange",
    sushiswap_v2_factory: "exchange",
    symbiosis: "bridge",
    system: "infrastructure",
    taurusfi: "exchange",
    teleport: "bridge",
    tensor_swap: "nft",
    tessera_v: "exchange",
    thorchain: "bridge",
    thorchain_deposit: "bridge",
    thorchain_memo: "bridge",
    thorchain_node: "infrastructure",
    tibbir: "bridge",
    tokemak_messaging: "bridge",
    tornado_cash: "privacy",
    tornado_cash_nova: "privacy",
    trench: "exchange",
    trends: "exchange",
    truf_ccip_receiver: "bridge",
    tycho: "aggregator",
    uma_optimistic_oracle: "oracle",
    unattributed_coinjoin: "privacy",
    uniswap_permit2: "exchange",
    uniswap_universal_router: "exchange",
    uniswap_v1_exchange: "exchange",
    uniswap_v1_factory: "exchange",
    uniswap_v2_factory: "exchange",
    uniswap_v2_migrator: "exchange",
    uniswap_v2_pair: "exchange",
    uniswap_v2_router: "exchange",
    uniswap_v3_factory: "exchange",
    uniswap_v3_migrator: "exchange",
    uniswap_v3_pool: "exchange",
    uniswap_v3_position_manager: "exchange",
    uniswap_v3_router: "exchange",
    uniswap_v3_staker: "exchange",
    uniswap_v4: "exchange",
    uniswap_v4_position_manager: "exchange",
    uniswapx: "exchange",
    usdt0: "bridge",
    vault_liquid_unstake: "staking",
    virtuals: "exchange",
    voltr: "staking",
    vote: "infrastructure",
    wasabi_coinjoin: "privacy",
    whalestreet: "exchange",
    whirlpool_coinjoin: "privacy",
    winnables_ccip_receiver: "bridge",
    wintermute: "mev",
    wishing_pond: "bridge",
    woofi: "exchange",
    wormhole: "bridge",
    wormhole_cctp_with_executor: "bridge",
    wormhole_core_bridge: "bridge",
    wormhole_executor: "bridge",
    wormhole_post_message_shim: "bridge",
    wormhole_verify_vaa_shim: "bridge",
    xerc20_ccip_receiver: "bridge",
    xorca: "staking",
    xswap: "bridge",
    zcash_shielded: "privacy",
    zeroex: "exchange",
    zerofi: "exchange",
    zkbob: "privacy",
    zksync_bridge: "bridge",
    zodiac: "safe"
  },
  names: {
    aave_ccip: "Aave a.DI",
    aave_gateway: "Aave Chain Gateway",
    aave_gho: "Aave GHO",
    aave_governance: "Aave Governance",
    aave_safety_module: "Aave Safety Module",
    aave_umbrella: "Aave Umbrella",
    aave_v2: "Aave V2",
    aave_v3: "Aave V3",
    aave_v4: "Aave V4",
    account_closure: "Account closure",
    accounting_ccip_receiver: "Bridge accounting",
    across: "Across Protocol",
    address_lookup_table: "Address Lookup Table",
    aerodrome: "Aerodrome / Velodrome",
    aldrin: "Aldrin",
    aldrin_v2: "Aldrin v2",
    algebra: "Algebra",
    algebra_router: "Algebra",
    allbridge_core: "Allbridge Core",
    allbridge_core_cctp: "Allbridge Core CCTP",
    alphaq: "AlphaQ",
    ambient: "Ambient",
    amnis: "Amnis",
    angstrom: "Angstrom",
    ape_church: "Ape Church",
    aquifer: "Aquifer",
    arbitrage_bot_foaft: "Arbitrage Bot (FoaFt)",
    arbitrum_bridge: "Arbitrum Bridge",
    arbos: "ArbOS",
    arcas_ccip_receiver: "Arcas transfer",
    archer: "Archer",
    associated_token_account: "Associated Token Account",
    babylon_staking: "Babylon",
    backed_ccip_bridge: "Backed CCIP bridge",
    backed_ccip_receiver: "Backed CCIP receiver",
    balancer_v2: "Balancer V2",
    balancer_v3: "Balancer V3",
    banana_gun: "Banana Gun",
    bebop: "Bebop Blend",
    binaryfi: "BinaryFi",
    bisonfi: "BisonFi",
    bisonfi_predict: "BisonFi Predict",
    bitcoin_org: "Bitcoin.org",
    bitcoin_stamps: "Bitcoin Stamps",
    blur: "Blur Exchange",
    bonkswap: "Bonkswap",
    boop_fun: "Boop.fun",
    bpf_loader: "BPF Loader v1",
    bpf_loader2: "BPF Loader v2",
    bpf_loader_upgradeable: "BPF Upgradeable Loader",
    brc20: "BRC-20",
    bridge_ccip_receiver: "BridgeCCIP receiver",
    byreal: "Byreal",
    candide: "Candide",
    carrot: "Carrot",
    cashmere_cctp: "Cashmere CCTP",
    cashmere_cctp_program: "Cashmere CCTP",
    ccip_burnmint_token_pool: "Chainlink CCIP Burn-Mint Token Pool",
    ccip_cctp_token_pool: "Chainlink CCIP CCTP Token Pool",
    ccip_fee_quoter: "Chainlink CCIP Fee Quoter",
    ccip_lockrelease_token_pool: "Chainlink CCIP Lock-Release Token Pool",
    ccip_offramp: "Chainlink CCIP OffRamp",
    ccip_prover: "CCIP Intent Prover",
    ccip_rmn_remote: "Chainlink CCIP RMN Remote",
    ccip_router: "Chainlink CCIP Router",
    ccipeth_ccip_receiver: "CCIPeth",
    cctp: "Circle CCTP",
    cctp_message_transmitter: "Circle CCTP Message Transmitter",
    cctp_message_transmitter_v2: "Circle CCTP Message Transmitter V2",
    cctp_token_messenger_minter: "Circle CCTP Token Messenger Minter",
    cctp_token_messenger_minter_v2: "Circle CCTP Token Messenger Minter V2",
    chainflip: "Chainflip",
    chainlink_automation: "Chainlink Automation",
    chainlink_ccip: "Chainlink CCIP",
    chainlink_data_feeds: "Chainlink Data Feeds",
    chainlink_data_streams: "Chainlink Data Streams",
    chainlink_direct_request: "Chainlink Direct Request",
    chainlink_functions: "Chainlink Functions",
    chainlink_staking: "Chainlink Staking v0.2",
    chainlink_vrf: "Chainlink VRF v2.5",
    circle_bridge_kit: "Circle Bridge Kit",
    circle_ccts: "Circle Cross-Chain Token Service",
    circle_fiattokenfactory: "Circle FiatTokenFactory",
    circle_usdc_xrpl: "Circle USDC on XRPL",
    compound_v3: "Compound III",
    compute_budget: "Compute Budget",
    conditional_tokens: "Conditional Tokens",
    coredao: "Core DAO",
    cosmos_authz: "Cosmos authz",
    cosmos_bank: "Cosmos bank",
    cosmos_distribution: "Cosmos staking rewards",
    cosmos_feegrant: "Cosmos fee grants",
    cosmos_gov: "Cosmos governance",
    cosmos_staking: "Cosmos staking",
    cosmwasm: "CosmWasm",
    counterparty: "Counterparty",
    cowswap: "CoW Swap",
    credit_coop_bridge: "Credit Coop Bridge",
    crema: "Crema",
    cropper: "Cropper",
    cryptopunks: "CryptoPunks",
    curve: "Curve pools",
    curve_steth: "Curve ETH/stETH",
    custom_staking_ccip_receiver: "CCIP custom staking receiver",
    da_builder: "DA Builder",
    defituna: "DefiTuna",
    denali: "Denali",
    deriverse: "Deriverse",
    dexlab: "DexLab",
    dflow_aggregator_v4: "DFlow",
    drift_ccip_receiver: "Drift TransferDetail",
    ed25519_program: "Ed25519 Signature Verify",
    eigenlayer: "EigenLayer",
    eip7702: "EIP-7702 delegation",
    ekubo: "Ekubo",
    ens: "ENS",
    enso: "Enso",
    erc1155: "ERC1155",
    erc20: "ERC20",
    erc4337: "ERC-4337",
    erc4626: "ERC4626",
    erc721: "ERC721",
    ethena: "Ethena",
    ether_ccip_receiver: "Ether CCIP receiver",
    etherfi: "ether.fi",
    euler: "Euler EVC",
    flint: "Flint",
    fluid: "Fluid",
    fluid_dex: "Fluid DEX",
    flux: "Flux",
    fluxbeam: "FluxBeam",
    folks_finance: "Folks Finance",
    frax_ether: "Frax Ether",
    gatorswap: "GatorSwap",
    gavel: "Gavel",
    generic: "Generic",
    gnosis_safe: "Gnosis Safe",
    goonfi_v2: "GoonFi v2",
    goosefx_gamma: "GooseFX Gamma",
    guacswap: "Guacswap",
    gyd_escrow_ccip_receiver: "GYD L1 CCIP escrow",
    hadron: "Hadron",
    heaven: "Heaven",
    helium_treasury: "Helium Treasury Management",
    hop: "Hop",
    huma: "Huma",
    humidifi: "HumidiFi",
    hylo_exchange: "Hylo Exchange",
    hylo_stability_pool: "Hylo Stability Pool",
    hyperlane: "Hyperlane",
    hyperliquid_account: "Hyperliquid account",
    hyperliquid_bridge: "Hyperliquid bridge",
    hyperliquid_bridge2: "Hyperliquid Bridge2",
    hyperliquid_evm: "HyperEVM via HyperCore",
    hyperliquid_staking: "Hyperliquid staking",
    hyperliquid_trading: "Hyperliquid trading",
    hyperliquid_transfer: "Hyperliquid transfers",
    hyperliquid_validator: "Hyperliquid validators and deployers",
    hyperliquid_vault: "Hyperliquid vaults",
    ibc_core: "IBC relayer",
    ibc_transfer: "IBC transfer",
    invariant: "Invariant",
    jaredfromsubway: "jaredfromsubway",
    joinmarket_coinjoin: "JoinMarket CoinJoin",
    jupiter_dca: "Jupiter DCA",
    jupiter_lend_earn: "Jupiter Lend Earn",
    jupiter_limit_order: "Jupiter Limit Order",
    jupiter_limit_order_v2: "Jupiter Limit Order v2",
    jupiter_order_engine: "Jupiter Order Engine",
    jupiter_perps: "Jupiter Perps",
    jupiter_rfq_v2: "Jupiter RFQ",
    jupiter_v4: "Jupiter v4",
    jupiter_v6: "Jupiter",
    juplend_amm: "JupLend AMM",
    kipseli: "Kipseli",
    kmon_minter_ccip_receiver: "Kmon minter",
    kyber_legacy: "Kyber Network",
    kyberswap_fairflow: "KyberSwap FairFlow",
    kyberswap_limit_order: "KyberSwap Limit Order",
    kyberswap_meta_aggregator: "KyberSwap",
    kyberswap_zap: "KyberSwap Zap",
    laposte: "LaPoste",
    layerzero_oft: "LayerZero OFT",
    layerzero_v1: "LayerZero V1",
    layerzero_v2: "LayerZero V2",
    lemmingsfi: "LemmingsFi",
    lido: "Lido",
    lifi: "LI.FI",
    lifi_receivers: "LI.FI Receiver",
    lifi_solana_program_1: "LI.FI Tracker",
    lifinity_v2: "Lifinity v2",
    lighthouse: "Lighthouse",
    limitbreak_payment_processor: "Payment Processor (Limit Break)",
    linea_bridge: "Linea Bridge",
    linear_ccip_receiver: "Linear withdrawal",
    liquidswap: "Liquidswap",
    loader_v4: "Loader v4",
    lombard: "Lombard",
    m_swap: "M Swap",
    magic_eden_v2: "Magic Eden v2",
    maker_dss: "Maker DSS",
    manifest: "Manifest",
    maple: "Maple",
    marinade: "Marinade Finance",
    maverick_v2: "Maverick V2",
    mayan: "Mayan",
    mayan_cpi_proxy: "Mayan CPI Proxy",
    mayan_fast_mctp: "Mayan Fast MCTP",
    mayan_fee_manager: "Mayan Fee Manager",
    mayan_mctp: "Mayan MCTP",
    mayan_spl_utils: "Mayan SPL Utils",
    mercurial: "Mercurial",
    metadao: "MetaDAO",
    metamask_bridge: "MetaMask Bridge",
    metamask_delegation: "MetaMask Delegation Framework",
    metamask_swaps: "MetaMask Swaps",
    metaplex_bubblegum: "Metaplex Bubblegum",
    metaplex_core: "Metaplex Core",
    metaplex_token_metadata: "Metaplex Token Metadata",
    meteora_damm_v2: "Meteora DAMM v2",
    meteora_dbc: "Meteora Dynamic Bonding Curve",
    meteora_dlmm: "Meteora DLMM",
    meteora_pools: "Meteora Pools",
    metric: "Metric",
    mev_bot: "MEV Bot",
    monero_ringct: "Monero RingCT",
    moonit: "Moonit",
    morpho_blue: "Morpho Blue",
    morpho_bundler3: "Morpho Bundler3",
    mtoken: "MToken",
    multi_lock_mint_ccip_receiver: "Multi lock/mint ERC-721 pool",
    multicall: "Multicall",
    native_ccip_receiver: "Native bridge transfer",
    native_loader: "Native Loader",
    native_transfer: "Native transfer",
    near_intents: "NEAR Intents",
    nft_floor_ccip_receiver: "NFT floor price message",
    noble_forwarding: "Noble forwarding",
    obric_v2: "Obric v2",
    obsidian: "Obsidian",
    odos: "Odos V2",
    okx_dex_router: "OKX DEX Router",
    okx_xbridge: "OKX XBridge",
    omni_layer: "Omni Layer",
    omnipair: "Omnipair",
    one_dex: "1DEX",
    oneinch: "1inch",
    oneinch_executor: "1inch Executor",
    op_fork_bridge: "OP Fork Bridges",
    op_return_data: "OP_RETURN data",
    op_stack_bridge: "OP Stack Bridge",
    op_stack_l1_block: "OP Stack L1Block",
    openbook_v2: "OpenBook v2",
    orca_v1: "Orca v1",
    orca_v2: "Orca v2",
    orca_whirlpool: "Orca Whirlpool",
    ordinals: "Ordinals",
    origin_protocol: "Origin Protocol",
    osmosis_swap: "Osmosis",
    outland: "Outland",
    packed_steps: "Packed step executor",
    pancakeswap_factory: "PancakeSwap",
    pancakeswap_router: "PancakeSwap",
    pancakeswap_solana: "PancakeSwap",
    pancakeswap_v3_pool: "PancakeSwap",
    pangolin_v3: "Pangolin V3",
    paraswap: "ParaSwap",
    pendle: "Pendle",
    penguin: "Penguin",
    perena: "Perena",
    perena_star_v2: "Perena Star v2",
    phoenix: "Phoenix",
    phoenix_eternal: "Phoenix Eternal",
    polygon_cdk_bridge: "CDK Unified Bridge",
    polygon_pos_bridge: "Polygon PoS Bridge",
    polymarket_ctf_exchange: "Polymarket CTF Exchange",
    polymarket_neg_risk: "Polymarket Neg Risk",
    polymarket_uma_adapter: "Polymarket UMA Adapter",
    pons_v2_curve: "Pons V2 curve",
    pons_v2_factory: "Pons V2",
    privacy_pools: "Privacy Pools / 0xbow",
    private_packed_searchers: "Private command executor",
    program_metadata: "Program Metadata",
    pumpfun: "pump.fun",
    pumpfun_fee: "pump.fun fees",
    pumpswap_amm: "PumpSwap",
    quantum: "Quantum",
    quay: "Quay",
    railgun: "RAILGUN",
    rare_bridge_ccip_receiver: "Rare Bridge",
    raydium_amm_v4: "Raydium AMM v4",
    raydium_clmm: "Raydium CLMM",
    raydium_cpmm: "Raydium CPMM",
    raydium_launchlab: "Raydium LaunchLab",
    relay: "Relay",
    ripple_rlusd: "Ripple USD",
    riptide: "Riptide",
    rootstock: "Rootstock",
    runes: "Runes",
    runespear: "Runespear / SuperEarn",
    runner_rodeo: "RunnerRodeo",
    saber: "Saber",
    saber_decimals: "Saber (Decimals)",
    sanctum_infinity: "Sanctum Infinity",
    sanctum_multi_validator: "Sanctum Multi-Validator Pool",
    sanctum_prop_s: "Sanctum Prop S",
    sanctum_router: "Sanctum Router",
    sanctum_single_validator: "Sanctum Single-Validator Pool",
    sanctum_sols: "Sanctum SOLS",
    sanctum_spl_stake_pool: "Sanctum SPL Stake Pool",
    saros: "Saros",
    saros_dlmm: "Saros DLMM",
    scale_amm: "Scale AMM",
    scale_vmm: "Scale VMM",
    scorch: "Scorch",
    scorch_2: "Scorch",
    scroll_bridge: "Scroll Bridge",
    seaport: "Seaport",
    secp256k1_program: "Secp256k1 Signature Verify",
    sky_usds: "Sky / USDS",
    socket: "Socket",
    solayer: "Solayer",
    solfi: "SolFi",
    solfi_v2: "SolFi v2",
    soucore_ccip_receiver: "SOUCore CCIP receiver",
    spl_memo_v1: "Memo v1",
    spl_memo_v2: "Memo",
    spl_token: "SPL Token",
    spl_token_2022: "Token-2022",
    spl_token_swap: "SPL Token Swap",
    stabble_clmm: "Stabble CLMM",
    stabble_stable_swap: "Stabble Stable Swap",
    stabble_weighted_swap: "Stabble Weighted Swap",
    stableswap: "Stableswap",
    stacks: "Stacks",
    stake: "Stake Program",
    stargate: "Stargate Finance",
    stepn: "StepN",
    strap_guard: "STRAP transaction guard",
    sushiswap_router: "SushiSwap",
    sushiswap_v2_factory: "SushiSwap",
    symbiosis: "Symbiosis",
    system: "System Program",
    taurusfi: "TaurusFi",
    teleport: "Teleport / Abridge",
    tensor_swap: "Tensor Swap",
    tessera_v: "TesseraV",
    thorchain: "THORChain",
    thorchain_deposit: "THORChain",
    thorchain_memo: "THORChain-style memo",
    thorchain_node: "THORChain node operations",
    tibbir: "Tibbir Bridge",
    tokemak_messaging: "Tokemak Cross-Chain Messaging",
    tornado_cash: "Tornado Cash",
    tornado_cash_nova: "Tornado Cash Nova",
    trench: "Trench",
    trends: "Trends",
    truf_ccip_receiver: "TRUF transfer",
    tycho: "Tycho",
    uma_optimistic_oracle: "UMA Optimistic Oracle",
    unattributed_coinjoin: "Unattributed CoinJoin",
    uniswap_permit2: "Permit2",
    uniswap_universal_router: "Uniswap Universal Router",
    uniswap_v1_exchange: "Uniswap V1",
    uniswap_v1_factory: "Uniswap V1",
    uniswap_v2_factory: "Uniswap V2",
    uniswap_v2_migrator: "Uniswap V2 Migrator",
    uniswap_v2_pair: "Uniswap V2",
    uniswap_v2_router: "Uniswap V2",
    uniswap_v3_factory: "Uniswap V3",
    uniswap_v3_migrator: "Uniswap V3 Migrator",
    uniswap_v3_pool: "Uniswap V3",
    uniswap_v3_position_manager: "Uniswap V3 Positions",
    uniswap_v3_router: "Uniswap V3",
    uniswap_v3_staker: "Uniswap V3 Staker",
    uniswap_v4: "Uniswap V4",
    uniswap_v4_position_manager: "Uniswap V4 Positions",
    uniswapx: "UniswapX",
    usdt0: "USDT0 / Legacy Mesh",
    vault_liquid_unstake: "VaultLiquidUnstake",
    virtuals: "Virtuals",
    voltr: "Voltr",
    vote: "Vote Program",
    wasabi_coinjoin: "Wasabi CoinJoin",
    whalestreet: "WhaleStreet",
    whirlpool_coinjoin: "Whirlpool CoinJoin",
    winnables_ccip_receiver: "Winnables Ccip Receiver",
    wintermute: "Wintermute Market Maker",
    wishing_pond: "Wishing Pond",
    woofi: "WOOFi",
    wormhole: "Wormhole",
    wormhole_cctp_with_executor: "Wormhole CCTP With Executor",
    wormhole_core_bridge: "Wormhole Core Bridge",
    wormhole_executor: "Wormhole Executor",
    wormhole_post_message_shim: "Wormhole Post Message Shim",
    wormhole_verify_vaa_shim: "Wormhole Verify VAA Shim",
    xerc20_ccip_receiver: "CCIP xERC20 transfer",
    xorca: "xORCA",
    xswap: "XSwap",
    zcash_shielded: "Zcash shielded pools",
    zeroex: "0x",
    zerofi: "ZeroFi",
    zkbob: "zkBob",
    zksync_bridge: "ZK Stack Bridge",
    zodiac: "Zodiac"
  }
};

// src/metadata-analytics/protocolNames.ts
var PROTOCOL_CATALOG_CATEGORIES = [
  "bridge",
  "exchange",
  "aggregator",
  "lending",
  "flashloan",
  "derivatives",
  "safe",
  "account_abstraction",
  "governance",
  "oracle",
  "infrastructure",
  "erc20",
  "nft",
  "staking",
  "mev",
  "exploit",
  "privacy",
  "gambling",
  "other"
];
var SnapshotSchema = z.object({
  names: z.record(z.string(), z.string()).default({}),
  categories: z.record(z.string(), z.string()).default({})
});
var SNAPSHOT = SnapshotSchema.parse(protocol_names_generated_default);
var NAMES = Object.freeze(SNAPSHOT.names);
var CATEGORIES = Object.freeze(SNAPSHOT.categories);
var KNOWN_CATEGORIES = new Set(PROTOCOL_CATALOG_CATEGORIES);
function catalogProtocolIds() {
  return Object.keys(NAMES);
}
function protocolDisplayName(protocolId) {
  if (!protocolId) return void 0;
  const name = NAMES[protocolId];
  return name && name.trim() ? name : void 0;
}
var alnum = (text) => text.toLowerCase().replace(/[^a-z0-9]/g, "");
var families = globalSingleton("metadata-analytics/protocolFamilyNames", () => ({
  names: /* @__PURE__ */ new Map()
}));
function protocolFamilyName(namespace) {
  const key = (namespace ?? "").trim().toLowerCase();
  if (!key) return void 0;
  if (families.names.has(key)) return families.names.get(key);
  const want = alnum(key);
  let found;
  for (const [id, name] of Object.entries(NAMES)) {
    if (id !== key && !id.startsWith(`${key}_`)) continue;
    const words = name.trim().split(/\s+/);
    for (let count = 1; count <= words.length; count += 1) {
      const spelled = alnum(words.slice(0, count).join(""));
      if (spelled === want) found = words.slice(0, count).join(" ");
      if (spelled.length >= want.length) break;
    }
    if (found) break;
  }
  families.names.set(key, found);
  return found;
}
function protocolCategory(protocolId) {
  if (!protocolId) return void 0;
  const category = CATEGORIES[protocolId];
  return category && KNOWN_CATEGORIES.has(category) ? category : void 0;
}
function catalogCategories() {
  return CATEGORIES;
}

export { PROTOCOL_CATALOG_CATEGORIES, catalogCategories, catalogProtocolIds, protocolCategory, protocolDisplayName, protocolFamilyName };
//# sourceMappingURL=chunk-YPOL6ITK.js.map
//# sourceMappingURL=chunk-YPOL6ITK.js.map